module.exports = __webpack_public_path__ + "assets/media/evening.ba0b9386.mp3";